module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0105.jpg?v=40c29203";